import UI from "./elements.module"

class HeaderModule {
    private ui = new UI()
    private slideTimeout: ReturnType<typeof setTimeout> | null = null;
    private PERSIST_KEY = 'header-is-fixed';

    constructor() {
        this.checkPersistentHeaderState();
    }

    private checkPersistentHeaderState() {
        const header = this.ui.header;
        if (!header) return;

        const isStickySlide = header.getAttribute('data-sticky') === 'slide';
        const wasFixed = sessionStorage.getItem(this.PERSIST_KEY) === 'true';
        const isNotAtTop = window.scrollY > 0;

        if (isStickySlide && wasFixed && isNotAtTop) {
            header.setAttribute("data-header-box-shadow", "");
            header.classList.add("is-sliding-in");
            header.setAttribute("data-header-persist", "");
        }
    }

    addWatcherToHeaderOnScroll() {
        const scrollableWatcher = document.createElement("div")
        scrollableWatcher.setAttribute('data-observer-intercept', '')
        scrollableWatcher.style.height = "1px"
        scrollableWatcher.style.marginTop = "-1px"
        this.ui.header?.before(scrollableWatcher)
        this.ui.headerIntersect = document.querySelector("[data-observer-intercept]")
    }

    setHeaderShadow() {
        const onIntersect = (entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                const header = this.ui.header;
                if (!header) return;

                const isStickySlide = header.getAttribute('data-sticky') === 'slide';
                const shouldStick = !entry.isIntersecting;
                const delayAttr = header.getAttribute('data-sticky-delay');
                const delay = delayAttr ? parseInt(delayAttr, 10) : 5000;

                if (this.slideTimeout) {
                    clearTimeout(this.slideTimeout);
                    this.slideTimeout = null;
                }

                if (shouldStick) {
                    if (isStickySlide) {
                        const wasFixed = sessionStorage.getItem(this.PERSIST_KEY) === 'true';

                        if (wasFixed) {
                            header.setAttribute("data-header-box-shadow", "");
                            header.classList.add("is-sliding-in");
                            header.setAttribute("data-header-persist", "");
                        } else {
                            this.slideTimeout = setTimeout(() => {
                                header.setAttribute("data-header-box-shadow", "");
                                header.classList.add("is-sliding-in");
                                sessionStorage.setItem(this.PERSIST_KEY, 'true');
                            }, delay);
                        }
                    } else if (header.hasAttribute('data-sticky')) {
                        header.setAttribute("data-header-box-shadow", "");
                    }
                } else {
                    header.removeAttribute("data-header-box-shadow");
                    
                    if (isStickySlide) {
                        header.classList.remove("is-sliding-in");
                        header.removeAttribute("data-header-persist");
                        sessionStorage.removeItem(this.PERSIST_KEY);
                    }
                }
            });
        }

        const observer = new IntersectionObserver(onIntersect, { threshold: [0], rootMargin: "0px" })
        observer.observe((this.ui.headerIntersect as HTMLElement))
    }

    addBoxShadowWhenNotPrimaryBg() {
        if (!this.ui.heroSection?.getAttribute('class')?.includes('bg-')) {
            if (this.ui.header) this.ui.header.style.boxShadow = 'var(--shadow-md)';
        }
    }
}

export default HeaderModule
